import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isSending: boolean;
};

export const SendCommentSection = ({
  value,
  onChange,
  onSend,
  isSending,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">{t(RESOURCES.SendNoteLabel)}</Typography>
      <TextField
        multiline
        minRows={2}
        maxRows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t(RESOURCES.SendNotePlaceholder)}
        fullWidth
        size="small"
      />
      <Box>
        <Button
          variant="contained"
          size="small"
          startIcon={<SendIcon />}
          onClick={onSend}
          disabled={isSending || !value.trim()}
        >
          {t(RESOURCES.SendNoteButton)}
        </Button>
      </Box>
    </Stack>
  );
};
